module.exports = __webpack_public_path__ + "img/anket_ikon.80679c90.jpg";